var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "coli cost-of-living-calculator" }, [
    _c("div", { staticClass: "container py-5" }, [
      _c("div", { staticClass: "coli-header row justify-content-between" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-auto" }, [
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              {
                staticClass: "col-auto col-form-label",
                attrs: { for: "from" },
              },
              [_vm._v("Compared to:")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.compareFromId,
                      expression: "compareFromId",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "from" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.compareFromId = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Select your City"),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.fromPlaces, function (place) {
                    return _c(
                      "option",
                      {
                        key: place.Place_Id,
                        domProps: { value: place.Place_Id },
                      },
                      [_vm._v(_vm._s(place.FromPlace))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.comparison
        ? _c(
            "div",
            { staticClass: "coli-results" },
            [
              _vm._m(1),
              _vm._v(" "),
              _vm._l(_vm.comparisonData, function (comparison) {
                return _c(
                  "div",
                  {
                    key: comparison.key,
                    class: {
                      "comparison-group": true,
                      "comparison-group--higher": comparison.moreExpensive,
                    },
                  },
                  [
                    _c("div", { staticClass: "row flex-lg-row-reverse" }, [
                      _c("div", { staticClass: "col-lg-3 comparison-text" }, [
                        _c("p", { staticClass: "mb-0" }, [
                          _c("span", {
                            staticClass: "compare-percent",
                            domProps: {
                              innerHTML: _vm._s(comparison.percentText),
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "compare-text",
                            domProps: {
                              innerHTML: _vm._s(comparison.compareText),
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-lg-9 comparison-graph" }, [
                        _c("p", {
                          staticClass: "compare-title compare-category mb-1",
                          domProps: { innerHTML: _vm._s(comparison.titleText) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "progress" }, [
                          _c("div", {
                            staticClass: "progress-bar",
                            style: { width: comparison.percentText },
                            attrs: {
                              role: "progressbar",
                              "aria-valuenow": comparison.percent,
                              "aria-valuemin": "0",
                              "aria-valuemax": "100",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-auto" }, [
      _c("p", { staticClass: "h1 text-uppercase" }, [_vm._v("Cost of Living")]),
      _vm._v(" "),
      _c("p", [_vm._v("Checkout how prices in your city compare to ours.")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row justify-content-lg-end" }, [
      _c("div", { staticClass: "col-lg-3" }, [
        _c("p", { staticClass: "small mb-1 text-white" }, [
          _vm._v("\n\t\t\t\t\t\tAverage prices in Cincinnati are:\n\t\t\t\t\t"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-right" }, [
      _c("p", { staticClass: "text-white small mb-0" }, [
        _c("em", [
          _vm._v("All cost of living data provided by\n\t\t\t\t\t"),
          _c(
            "a",
            {
              staticClass: "text-white",
              attrs: { href: "https://www.c2er.org/", target: "_blank" },
            },
            [
              _vm._v(
                "The Council for Community & Economic\n\t\t\t\t\t\tResearch"
              ),
            ]
          ),
          _vm._v("."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }